import { getPrivateSessionState, subscribePrivateSession } from "@/lib/api/private-session";
import { installSessionChannel } from "@/shared/services/sessionChannel";


import { QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { Fragment, useState, useSyncExternalStore } from "react";
import { createPortalQueryClient } from "@/lib/query/core/query-client";

export function QueryProvider({ children }: { children: ReactNode }) {
  const [queryClient] = useState(() => {
    const client = createPortalQueryClient();
    installSessionChannel(client);
    return client;
  });

  const session = useSyncExternalStore(subscribePrivateSession, getPrivateSessionState);
  return <QueryClientProvider client={queryClient}><Fragment key={session.generation}>{children}</Fragment></QueryClientProvider>;
}
